import { DownloadReceipt } from "@/services/bookinghistory.service";
import { useAuthStore } from "@/stores/auth.store";

export const downloadTransactionReceipt = async (paymentId: string) => {
  if (!paymentId) {
    throw new Error("Payment ID is missing.");
  }

  const agentCompanySellerId =
    useAuthStore.getState().user?.agentCompanySellerId ?? "";

  if (!agentCompanySellerId) {
    throw new Error("Agent information is missing.");
  }

  // Open the tab immediately from the button click.
  const newTab = window.open("", "_blank");

  if (!newTab) {
    throw new Error("Unable to open new tab. Please allow pop-ups.");
  }

  // Show loading while waiting for the PDF.
  newTab.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Loading Receipt</title>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <style>
          body {
            margin: 0;
            min-height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            font-family: Arial, sans-serif;
            background: #ffffff;
            color: #333333;
          }

          .container {
            text-align: center;
          }

          .spinner {
            width: 40px;
            height: 40px;
            margin: 0 auto 16px;
            border: 4px solid #e5e7eb;
            border-top-color: #004999;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          .text {
            font-size: 16px;
          }

          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="spinner"></div>
          <div class="text">Downloading Transaction Receipt...</div>
        </div>
      </body>
    </html>
  `);

  newTab.document.close();

  try {
    const response = await DownloadReceipt({
      agentCompanySellerId,
      paymentId,
    });

    const { fileUrl } = response.data;

    if (!fileUrl) {
      throw new Error("Download file URL is missing.");
    }

    // Open the PDF in the same tab.
    newTab.location.href = fileUrl;
  } catch (error) {
    // Show error in the already opened tab.
    newTab.document.body.innerHTML = `
      <div style="
        font-family: Arial, sans-serif;
        text-align: center;
        padding: 40px 20px;
      ">
        <h2>Unable to download transaction receipt</h2>
        <p>Please try again.</p>
      </div>
    `;

    throw error;
  }
};